import { Component, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';

import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-file-drag-drop',
  templateUrl: './file-drag-drop.component.html',
  styles: [`
    .max-word{
      color:blue !important;
      font-style: italic !important;
      font-size: 10px;
  }
  `]
})
export class FileDragDropComponent {

  //@Output() selectedFiles= new EventEmitter();
  maxUploadSizeInMb: number = environment.MAX_UPLOAD_SIZE_IN_MB;
  files: File[] = [];
  selectedFiles: File[] = [];
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;

  uploadFile(event) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name)
      this.selectedFiles.push(element);
    }

  }
  deleteAttachment(index) {
    this.files.splice(index, 1);
    this.selectedFiles.splice(index, 1);
    this.fileInput.nativeElement.value = null;
  }
}
